<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">

<div *ngIf="isInMarketplaceMode()">
    <app-header></app-header>
</div>
<div id="app" class="h-100 app" [ngClass]="settings.theme" [class.main-toolbar-fixed]="settings.mainToolbarFixed"
    [dir]="(settings.rtl) ? 'rtl' : 'ltr'">
    <main class="d-flex flex-column wrapper {{isInMarketplaceMode() ? 'margin-marketplace' : 'margin-admin' }}">
           
        <div style="min-height: 1500px;">
            <app-toast-container></app-toast-container>
            <router-outlet (activate)="onActivate($event)"></router-outlet>
        </div>

        <app-footer></app-footer>

    </main>
    
</div>